import { Handle } from 'rc-slider';
import React from 'react';
import Popover from '../Popover';

const EssentialsHandle = (props) => {
  const { value, ...restProps } = props;
  delete restProps.dragging;
  return (
    <Handle value={value} {...restProps}>
      <Popover
        shouldPop={value === 100000}
        tip={
          <>
            <p>
              <strong>Need more?</strong>
            </p>
            <p>
              <a href="/contact-us-form/">Contact us</a> for a custom plan. Or,
              switch to Pro for higher volumes and additional features like a
              dedicated IP.
            </p>
          </>
        }
      />
    </Handle>
  );
};

export default EssentialsHandle;
